import { SetProd } from 'sos-models';
import axios from '../../config/axios';

export function list(episodicId: number): Promise<Partial<SetProd>[]> {
	return axios
		.get<Partial<SetProd>[]>(`/api/episodics/${episodicId}/set-prods`)
		.then((response) => response.data);
}
